"use client"

import Image from "next/image"
import Link from "next/link"
import { Phone } from "lucide-react"
import { useTheme } from "@/components/ThemeProvider"
import { ThemeToggle } from "@/components/ThemeToggle"

function toTelHref(phone: string) {
  if (phone.startsWith("0")) return `tel:+33${phone.slice(1)}`
  return `tel:${phone}`
}

interface PublicHeaderProps {
  phone?: string | null
}

export function PublicHeader({ phone }: PublicHeaderProps) {
  const { theme } = useTheme()

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        paddingTop: "env(safe-area-inset-top)",
        background: theme === "dark" ? "rgba(15,23,42,0.88)" : "rgba(255,255,255,0.85)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        boxShadow:
          theme === "dark"
            ? "inset 0 1px 0 rgba(255,255,255,0.06), 0 1px 0 rgba(51,65,85,0.6)"
            : "inset 0 1px 0 rgba(255,255,255,0.9), 0 1px 0 rgba(226,232,240,0.8)",
      }}
    >
      <style>{`
        .header-phone-text { display: inline; }
        .header-rdv-btn { display: inline-flex; }
        @media (max-width: 640px) {
          .header-phone-text { display: none; }
          .header-rdv-btn { display: none; }
        }
      `}</style>
      <div
        style={{
          maxWidth: 1160,
          margin: "0 auto",
          padding: "0 20px",
          height: 60,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Link href="/">
          <Image
            src={
              theme === "dark"
                ? "/assets/LJS PLOMBERIE_logo_clair.png"
                : "/assets/LJSPLOMBERIE_logo.png"
            }
            alt="LJS Plomberie"
            width={114}
            height={38}
            style={{ objectFit: "contain" }}
            priority
          />
        </Link>

        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <ThemeToggle />

          {/* Icône téléphone (mobile) + numéro (desktop) */}
          {phone && (
            <a
              href={toTelHref(phone)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                fontSize: 13,
                fontWeight: 500,
                color: "var(--ljs-text-muted)",
                textDecoration: "none",
                padding: "8px 10px",
                borderRadius: 8,
                transition: "color 0.15s",
              }}
            >
              <Phone size={16} strokeWidth={2} />
              <span className="header-phone-text">{phone}</span>
            </a>
          )}

          <Link
            href="/rdv"
            className="header-rdv-btn"
            style={{
              background: "var(--ljs-cta-gradient)",
              color: "#fff",
              fontSize: 14,
              fontWeight: 700,
              padding: "9px 22px",
              borderRadius: 9,
              textDecoration: "none",
              alignItems: "center",
              gap: 6,
              boxShadow: "0 2px 14px var(--ljs-cta-shadow)",
              fontFamily: "var(--font-heading)",
              transition: "transform 0.15s, box-shadow 0.15s",
            }}
          >
            Prendre un RDV
          </Link>
        </div>
      </div>
    </header>
  )
}
